var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/stop_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4466_474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.625,
    width: 16,
    height: 16,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4466_474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stop_circle",
    d: "M6.06937 10.5555H11.1805V5.44445H6.06937V10.5555ZM8.62492 14.6667C7.71011 14.6667 6.84715 14.4917 6.03604 14.1417C5.22492 13.7917 4.51751 13.3148 3.9138 12.7111C3.3101 12.1074 2.83325 11.4 2.48325 10.5889C2.13325 9.77777 1.95825 8.91481 1.95825 8C1.95825 7.07777 2.13325 6.21111 2.48325 5.4C2.83325 4.58888 3.3101 3.88333 3.9138 3.28333C4.51751 2.68333 5.22492 2.20833 6.03604 1.85833C6.84715 1.50833 7.71011 1.33333 8.62492 1.33333C9.54714 1.33333 10.4138 1.50833 11.2249 1.85833C12.036 2.20833 12.7416 2.68333 13.3416 3.28333C13.9416 3.88333 14.4166 4.58888 14.7666 5.4C15.1166 6.21111 15.2916 7.07777 15.2916 8C15.2916 8.91481 15.1166 9.77777 14.7666 10.5889C14.4166 11.4 13.9416 12.1074 13.3416 12.7111C12.7416 13.3148 12.036 13.7917 11.2249 14.1417C10.4138 14.4917 9.54714 14.6667 8.62492 14.6667Z",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircle);
export default __webpack_public_path__ + "static/media/stop_circle.9b1a3db8.svg";
export { ForwardRef as ReactComponent };